import * as React from "react";
const SvgFiRrLowVision = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-low-vision_svg__a)">
      <path
        fill="#062147"
        d="M14.828 19.071a1.01 1.01 0 0 1-.534 1.707l-.024.004a1.01 1.01 0 0 1-.888-.285L2.216 9.332a1.007 1.007 0 0 1-.083-1.334l.013-.016a1.01 1.01 0 0 1 1.505-.088zm-14.3-8.598c-.143.272-.26.514-.35.708a1.98 1.98 0 0 0 0 1.64c.041.091.094.2.147.308l5.915 5.915a6 6 0 0 0 3.094 1.662c.537.116.902-.524.514-.912zm23.18 11.82a.999.999 0 1 1-1.415 1.414l-22-22A.999.999 0 1 1 1.707.293l4.268 4.268C7.813 3.525 9.837 3.001 12 3.001c6.192 0 9.72 4.237 11.271 6.763a4.91 4.91 0 0 1 0 5.162c-.632 1.03-1.678 2.473-3.178 3.753zM7.454 6.041 9.243 7.83a5.01 5.01 0 0 1 6.293.636 5.01 5.01 0 0 1 .636 6.293l2.502 2.502c1.368-1.135 2.322-2.45 2.894-3.38a2.92 2.92 0 0 0 0-3.069c-1.333-2.17-4.349-5.81-9.567-5.81-1.619 0-3.144.35-4.546 1.04m7.252 7.252a3.01 3.01 0 0 0-.585-3.414 3.005 3.005 0 0 0-3.414-.585l4 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-low-vision_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLowVision;
